
AddPageSwapTrigger(function() {
    var hostMatch = $('.share-whatsapp').attr('href').match(new RegExp("(https?):\/\/([A-Za-z0-9\-\.]+(\/ca|\/au)?)"));
    var host = hostMatch[2];

    $('.share-whatsapp').attr('href', hostMatch[1] + '://' + host + '/share/whatsapp' + document.location.pathname + document.location.search);
    $('.share-facebook').attr('href', hostMatch[1] + '://' + host + '/share/facebook' + document.location.pathname + document.location.search);
    $('.share-twitter').attr('href', hostMatch[1] + '://' + host + '/share/twitter' + document.location.pathname + document.location.search);

});

AddPageSwapTrigger(function() {
    $('.share-btn').click(function() {
            var text = $(this).data('text');
            if (navigator.share) {

				navigator.share({
                    //title: 'Test',
                    text: text,
                    url: 'https://' + window.location.host + window.location.pathname + window.location.search
                });

				gtag('event', 'share', { 'event_category': 'engagement', 'event_label': 'Mobile Share API', 'label': text, 'value': 'https://' + window.location.host + window.location.pathname + window.location.search });

            } else {
                $('#shareModal').modal('show');
            }
        });
});
